var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isInternalUrl_1 = __importDefault(require("../isInternalUrl"));
function shouldConvert(url) {
    return (
    // url must not be null
    !!url &&
        // don't convert these urls
        !/concur\./i.test(url) &&
        !/ultipro\./i.test(url) &&
        // make sure it's a henderson url
        (0, isInternalUrl_1.default)(url));
}
exports.default = shouldConvert;
//# sourceMappingURL=shouldConvert.js.map